import { render, staticRenderFns } from "./DepartmentTag.vue?vue&type=template&id=62c2f23e&scoped=true"
import script from "./DepartmentTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentTag.vue?vue&type=style&index=0&id=62c2f23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2f23e",
  null
  
)

export default component.exports